'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEnd2EndLaunchUrl = undefined;

var _bingo = require('tg-core-api/lib/bingo');

var _bingo2 = _interopRequireDefault(_bingo);

var _action = require('../../lib/action');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getEnd2EndLaunchUrl = exports.getEnd2EndLaunchUrl = function getEnd2EndLaunchUrl(playerSessionID, data) {
  return (0, _action.makeApiCallAction)('GET_BINGO_LAUNCH_URL', _bingo2.default.getEnd2EndLaunchUrl(playerSessionID, data));
};

exports.default = {
  getEnd2EndLaunchUrl: getEnd2EndLaunchUrl
};